import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';
import { environment } from './environments/environment';

if (environment.production) {
  // Disable console methods in production
  console.log = () => {};
}

// The Google sign-in popup lands back here with ?status=... once the backend callback finishes.
// Hand the result to the opener through localStorage (its storage listener closes the modal)
// and close the popup instead of booting the whole panel inside it.
const authParams = new URLSearchParams(window.location.search);
const isGmailAuthPopup = localStorage.getItem('gmail_auth_popup') === '1' && authParams.has('status');

if (isGmailAuthPopup) {
  localStorage.removeItem('gmail_auth_popup');
  localStorage.setItem('gmail_auth_result', JSON.stringify(Object.fromEntries(authParams.entries())));
  window.close();
  // window.close() is ignored if the browser no longer treats this as a script-opened window.
  document.body.innerHTML = '<p style="font-family:sans-serif;text-align:center;margin-top:40vh">Google sign-in complete. You can close this window.</p>';
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    const appRoot = document.querySelector('[ng-version]');
    appRoot?.removeAttribute('ng-version');
  }).catch(err => console.error(err));
}
